export const getMetadataUrl = (path: string) =>
  `${process.env.GATSBY_MAIN_DOMAIN_URL}${path?.match(/\/$/) ? path : `${path}/`}`;
